import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["data"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useMemo } from "react";
import List from "@/components/List";
import ListRow from "@/components/Row/ListRow/index";
import ContentHeader from "@/components/ContentHeader";
import DateTab from "@/components/DateTab";
import { useChannelLiveScheduleQuery } from "@/hooks";
import NoContentMessage from "@/components/NoContentMessage";
import dayjs from "@/lib/day";
import styles from "@/styles/Channel.module.scss";
import { LIST_PAGE_LIMIT } from "@/lib/constants";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ChannelLiveSchedule(_ref) {
  let {
    id
  } = _ref;
  const {
    0: selectedDay,
    1: setDay
  } = useState(dayjs().format("YYYY-MM-DD"));
  const _useChannelLiveSchedu = useChannelLiveScheduleQuery({
      variables: {
        id,
        day: selectedDay,
        offset: 0,
        limit: LIST_PAGE_LIMIT
      }
    }),
    {
      data
    } = _useChannelLiveSchedu,
    result = _objectWithoutProperties(_useChannelLiveSchedu, _excluded);
  const items = data === null || data === void 0 ? void 0 : data.channelLiveSchedule;
  const headerText = useMemo(() => `${dayjs(selectedDay).format("M/D（dd）")}の番組`, [selectedDay]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.liveSchedule,
    children: [/*#__PURE__*/_jsx(ContentHeader, {
      text: headerText
    }), /*#__PURE__*/_jsx("div", {
      children: /*#__PURE__*/_jsx(DateTab, {
        selectedDay: selectedDay,
        onClick: setDay
      })
    }), /*#__PURE__*/_jsx("div", {
      className: styles.content,
      children: /*#__PURE__*/_jsx(List, _objectSpread(_objectSpread({}, result), {}, {
        itemComponent: ListRow,
        items: items,
        limit: LIST_PAGE_LIMIT,
        noContent: /*#__PURE__*/_jsx(NoContentMessage, {
          message: "\u3053\u306E\u65E5\u306E\u30E9\u30A4\u30D6\u306F\u3042\u308A\u307E\u305B\u3093\u3002"
        })
      }), `channel-${id}-live-${selectedDay}`)
    })]
  });
}